export interface StreetLightRenderConfig {
  readonly spacingM: number;
  /** Distance from the outer curb edge to the lamp-post centre. */
  readonly sidewalkInsetM: number;
  readonly heightM: number;
  readonly modernArterialHeightM: number;
  readonly neighbourhoodHeightM: number;
  readonly lightPoolRadiusM: number;
  readonly lightPoolLiftM: number;
}

/**
 * Proportions derived from the three user-supplied Vilnius twin-lamp
 * references. Placement remains inferred from official road centrelines.
 */
export const STREET_LIGHT_RENDER_CONFIG: Readonly<StreetLightRenderConfig> =
  Object.freeze({
    spacingM: 28,
    sidewalkInsetM: 0.48,
    heightM: 7.2,
    modernArterialHeightM: 8.4,
    neighbourhoodHeightM: 5.8,
    lightPoolRadiusM: 3.2,
    lightPoolLiftM: 0.07,
  });
